import React from 'react';
import { useParams } from 'react-router-dom';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import {Box, Button, Link, Typography} from '@mui/material';
import { useJourneyStep } from 'api/Journeys/journey_queries';
import { useAuth } from 'contexts/AuthContext';
import EditTemporalAttribute from 'components/EditTemporalAttribute';
import SpigotEdit from 'pages/Journeys/components/Sidebar/Spigot/SpigotEdit';
import SpigotDraft from 'pages/Journeys/components/Sidebar/Spigot/SpigotDraft';
import SpigotActive from 'pages/Journeys/components/Sidebar/Spigot/SpigotActive';
import SpigotHistory from 'pages/Journeys/components/Sidebar/Spigot/SpigotHistory';
import {flowStateChip} from '../../JourneyConstants';
import SpigotReport from './Spigot/SpigotReport';

const SpigotSidebar = ({ stepId : journeyStepId, hideSidebar }) => {
    const { id : journeyIdStr } = useParams();
    const journeyId = parseInt(journeyIdStr);
    const { axiosElementalApiCurrentOrg } = useAuth();

    const queryClient = useQueryClient();

    const { status, data: journeyStep, error, isFetching } = useJourneyStep(journeyId, journeyStepId);

    const mutationBaseUrl = `/flows/${journeyId}/steps/spigot/${journeyStepId}/spigot/draft`;

    console.log('SpigotSidebar', journeyStep);

    const createDraftMutation = useMutation(
        async () => {
            return await axiosElementalApiCurrentOrg.post(`${mutationBaseUrl}`);
        }, {
            onSuccess: (data) => {
                queryClient.invalidateQueries(['journey_step', journeyStepId]);
            }
        });

    const updateDraftMutation = useMutation(
        async (payload) => {
            return await axiosElementalApiCurrentOrg.put(`${mutationBaseUrl}`, payload);
        }, {
            onSuccess: (data) => {
                queryClient.invalidateQueries(['journey_step', journeyStepId]);
            }
        });

    const deleteDraftMutation = useMutation(
        async () => {
            return await axiosElementalApiCurrentOrg.delete(`${mutationBaseUrl}`);
        }, {
            onSuccess: (data) => {
                queryClient.invalidateQueries(['journey_step', journeyStepId]);
            }
        });

    const activateDraftMutation = useMutation(
        async () => {
            return await axiosElementalApiCurrentOrg.post(`${mutationBaseUrl}/activate`);
        }, {
            onSuccess: (data) => {
                queryClient.invalidateQueries(['journey_step', journeyStepId]);
            }
        });

    if( isFetching ){
        return <Box>Loading ...</Box>;
    }

    const statusBadge = flowStateChip(journeyStep.status, journeyStep.has_changes, 'small');

    return (
        <Box className='flow-sidebar__body' p={0}>
            <Box className='flow-sidebar__body-content'>
                <Box display='flex' flexDirection='column'>
                    <Box display='flex' flexDirection='column' p={1} className='spigot__step'>
                        <Box display='flex' justifyContent='space-between' style={{width: '100%', alignItems: 'center'}}>
                            <Typography variant='subtitle1' style={{display: 'inline-flex', alignItems: 'center'}}>Spigot <span style={{marginLeft: 10}}>{statusBadge}</span></Typography>
                        </Box>
                        <EditTemporalAttribute
                            attributeTypeLabel={'Spigot'}

                            active={journeyStep.spigot}
                            draft={journeyStep.spigot_draft}
                            history={journeyStep.spigot_history}
                            journeyStep={journeyStep}

                            ComponentEditDraft={SpigotEdit}
                            componentEditDraftProps={{
                                journeyId: journeyId,
                                journeyStepId: journeyStep.id
                            }}
                            ComponentDisplayDraft={SpigotDraft}
                            ComponentDisplayActive={SpigotActive}
                            ComponentDisplayHistory={SpigotHistory}

                            parentAllowsActivation={ journeyStep.status === 'active'}

                            mutationCreateDraft={createDraftMutation}
                            mutationUpdateDraft={updateDraftMutation}
                            mutationDeleteDraft={deleteDraftMutation}
                            mutationActivateDraft={activateDraftMutation}

                        />
                        {journeyStep.status === 'active' && <SpigotReport stepId={journeyStepId} />}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default SpigotSidebar;
